

const services = [
  {
    title: 'Project Management Services',
    tags: ['Schedule Management', 'Value Engineering', 'Capex and Opex Estimate'],
    icon: 'schedule'
  },
  {
    title: 'Mining Technical Services',
    tags: ['Mining Equipment Cost Estimation', 'Mining Project Financial Modeling', 'Project Due Diligence', 'Strategic Mine Planning', 'Mining Equipment Performance Evaluation'],
    icon: 'mine'
  },
  {
    title: 'Advisory Services',
    tags: ['Prospecting', 'Project Acquisition', 'Feasibility', 'Market and Risk analysis', 'Operations'],
    icon: 'advisory'
  }
];

export default services;
